import type { CylinderShape } from './cylinder-params';
import type { Rect } from './types';

/**
 * 원통에 투영한 영역(마플 `enCylinderizeSize` 대응).
 * 폭은 area.width·2/π 로 줄고 area 안에서 가운데 정렬한다.
 * 위·아래 경계의 양 끝이 area 밖으로 나가면(upSide < 0, downSide > 0) 그만큼 넓힌다.
 * 아래쪽 확장은 마플 표본이 없어 위쪽(고블렛잔 5775)과 같은 규칙을 적용한 것이다.
 */
export function enCylinderizeSize(params: CylinderShape): Rect {
  const { area, upSide, downSide } = params;
  const width = (area.width * 2) / Math.PI;
  const rise = Math.min(0, upSide);
  const drop = Math.max(0, downSide);
  return {
    left: area.left + (area.width - width) / 2,
    top: area.top + rise,
    width,
    height: area.height - rise + drop,
  };
}
